import React from 'react'

// components
import FormImages from '../../FormComponents/FormImages'
import FormBasicDetails from '../../FormComponents/FormBasicDetails'
import FormCategories from '../../FormComponents/FormCategories'
import FormDimensions from '../../FormComponents/FormDimensions'
import FormFeatured from '../../FormComponents/FormFeatured'
import FormRibbon from '../../FormComponents/FormRibbon'

export default function GeneralTab(props) {
    // props
    const {
        productImages,
        getImagesToBeSaved,

        formik,

        getDesc,

        categories,
        selectedCategories,
        setSelectedCategories,
        defaultCategories,
        setCategoriesToBeSaved,
        categoriesToBeSaved,
        errorInCategories,
        setErrorInCategories,

        ribbonColors,
    } = props

    return (
        <React.Fragment>
            {/* images */}
            <FormImages
                productImages={productImages}
                getImagesToBeSaved={getImagesToBeSaved}
            />

            {/* basic details */}
            <FormBasicDetails
                formik={formik}

                getDesc={getDesc}
            />

            {/* categories */}
            <FormCategories
                formik={formik}

                categories={categories}
                selectedCategories={selectedCategories}
                setSelectedCategories={setSelectedCategories}
                defaultCategories={defaultCategories}
                categoriesToBeSaved={categoriesToBeSaved}
                setCategoriesToBeSaved={setCategoriesToBeSaved}
                errorInCategories={errorInCategories}
                setErrorInCategories={setErrorInCategories}
            />

            {/* diemensions */}
            <FormDimensions
                formik={formik}
            />

            {/* featured */}
            <FormFeatured
                formik={formik}
            />

            {/* ribbon */}
            <FormRibbon
                formik={formik}

                ribbonColors={ribbonColors}
            />




        </React.Fragment>
    )
}
